import bluePlus from "../DatePeriodControlled/BluePlusCircle.svg";
import { isTerminal } from "../../../../constants";

import React from "react";

const BlueButton = ({ parentStyle, handler }) => {

    // const dispatch = useDispatch();

    // function deleteHandler(e) {
    //     dispatch(addPeriodHandlerCurrentRequest());
    // }

    return (
        <img
            onClick={handler}
            className={`${parentStyle}-delete`}
            src={bluePlus}
            alt="bluePlus" />
    );
};

const CommentInput = ({
    parentStyle,
    label,
    value,
    changeHandler,
    maxLength,
    stateProperty,
    basicInput,
    errorMessage,
    helper,
    type,
    width,
    withDeleteButton,
}) => {
    return (
        <div className={`${parentStyle}-comment__container`}>
            <label
                htmlFor="comment"
                className={`${parentStyle}-comment__label`}
            >
                {label}
            </label>

            {!isTerminal &&
                  withDeleteButton ? <div>
                    <input
                        style={{width: width ? width : "100%"}}
                        name="comment"
                        value={value ? value : ""}
                        onChange={(event) => changeHandler(event)}
                        maxLength={maxLength ? maxLength : null}
                        className={
                            !errorMessage
                                ? `${parentStyle}-comment`
                                : `${parentStyle}-commentError`
                        }
                        type={"text"}
                    />
                    <BlueButton
                        handler={withDeleteButton}
                        parentStyle={"comment"}
                    />
                </div> :
                <input
                style={{width: width ? width : "100%"}}
            name="comment"
            value={value ? value : ""}
            onChange={(event) => changeHandler(event)}
            maxLength={maxLength ? maxLength : null}
            className={
                !errorMessage
                    ? `${parentStyle}-comment`
                    : `${parentStyle}-commentError`
            }
            type={"text"}
        />

            }

            {isTerminal && <textarea
                name="comment"
                placeholder="Введите комментарий"
                rows={4}
                value={value ? value : ""}
                onChange={(event) => changeHandler(event)}
                maxLength={maxLength ? maxLength : null}
                className={
                    !errorMessage
                        ? `${parentStyle}-comment`
                        : `${parentStyle}-commentError`
                }
                type={"text"}
            />}
            {errorMessage ? (
                <div className="date-popup-selector__error-message">
                    {errorMessage}
                </div>
            ) : (
                <div className="date-popup-selector__buffer"></div>
            )}
            {helper && (
                <p className={`${parentStyle}-comment__underline`}>{helper}</p>
            )}
            {!basicInput && (
                <p className={`${parentStyle}-comment__underline`}>
                    <span className="required_text">* </span>
                    Поля обязательные для заполнения
                </p>
            )}
        </div>
    );
};

export default CommentInput;
